import {useEffect} from 'react';
import {Switch, Route, Redirect} from 'react-router-dom';
import axios from 'axios';
import {toast} from 'material-react-toastify';

import User from './singletons/User';
import GlobalEvents from './singletons/GlobalEvents';
import {AUTH, LOGIN, FORBIDDEN, LOG} from './constants/routing';
import AuthRoute from './AuthRoute';
import Login from './pages/Login';
import Forbidden from './pages/Forbidden';
import Log from './pages/Log';

const RouterTree = () => {
  useEffect(() => {
    const ejectId = axios.interceptors.response.use(null, (e) => {
      const deepestData = e.response?.data;
      const errors = deepestData?.errors;
      if (errors && errors.some((e) => e.status === 401)) {
        User.logout();
      }

      /* MUST rethrow */
      return Promise.reject(deepestData);
    });

    return () => axios.interceptors.response.eject(ejectId);
  }, []);

  useEffect(
    () =>
      GlobalEvents.listen((type, data) => {
        switch (type) {
          case 'unknownError':
            toast.error(data.printedError, {toastId: data.printedError});
            break;
          case 'forgotPassword':
            data.status === 'success'
              ? toast.success(
                `Reset password email has been sent to ${data.email}`,
              )
              : toast.error(
                `Error sending reset password email to ${data.email}`,
              );
            break;
          case 'addEntry':
            if (data.status === 'error') {
              toast.error(
                `${data.name}`,
              );
            }
            break;
          case 'addPost':
            if (data.status === 'error') {
              toast.error(
                `${data.name}`,
              );
            }
            break;
          case 'updatePost':
            if (data.status === 'error') {
              toast.error(
                `${data.name}`,
              );
            }
            break;
          case 'removeEntry':
            if (data.status === 'error') {
              toast.error(
                `${data.name}`,
              );
            }
            break;
          case 'updateUserPassword':
            if (data.status === 'success') {
              toast.success('Password was successfully updated');
            }
            break;
        }
      }),
    [],
  );

  return (
    <Switch>
      <Route path={AUTH}>
        <Switch>
          <Route exact path={LOGIN} component={Login} />
          <Route exact path={FORBIDDEN} component={Forbidden} />
        </Switch>
      </Route>
      <AuthRoute path={LOG}>
        <Log />
      </AuthRoute>
      <Redirect to={LOG} />
    </Switch>
  );
};

export default RouterTree;
